
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/goods-in-transit/[promotionSlug]",
      function () {
        return require("private-next-pages/personal/goods-in-transit/[promotionSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/goods-in-transit/[promotionSlug]"])
      });
    }
  